import {
  Box,
  Button,
  Grid,
  GridItem,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
} from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";
import { ReservationFilters as ReservationFiltersType } from "../../../hooks/useReservations";

interface ReservationFiltersProps {
  filters: ReservationFiltersType;
  onFiltersChange: (filters: Partial<ReservationFiltersType>) => void;
}

export function ReservationFilters({
  filters,
  onFiltersChange,
}: ReservationFiltersProps) {
  return (
    <Box mb={6} p={4} bg="white" borderRadius="lg" boxShadow="base">
      <Grid templateColumns={{ base: "1fr", md: "1fr 1fr auto" }} gap={4}>
        <GridItem>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <FiSearch color="gray.300" />
            </InputLeftElement>
            <Input
              placeholder="Buscar por cliente ou propriedade..."
              value={filters.search || ""}
              onChange={(e) => onFiltersChange({ search: e.target.value })}
            />
          </InputGroup>
        </GridItem>
        <GridItem>
          <Select
            placeholder="Filtrar por status"
            value={filters.status || ""}
            onChange={(e) =>
              onFiltersChange({
                status: e.target.value as ReservationFiltersType["status"],
              })
            }
          >
            <option value="waiting_checkin">Aguardando check-in</option>
            <option value="guest_in_house">Hóspede na casa</option>
            <option value="checkout_done">Check-out feito</option>
          </Select>
        </GridItem>
        <GridItem>
          <Button onClick={() => onFiltersChange({})} w="full">
            Limpar Filtros
          </Button>
        </GridItem>
      </Grid>
    </Box>
  );
}
